var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"bc-industry-tag"},[_vm._t("default"),_c(_setup.X,{on:{"click":function($event){return _vm.$emit('delete')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }